<template>
  <v-container fluid grid-list-sm style="padding: 8px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
        @click:row="selectRow"
        :footer-props="globalFooterOptions"
        :headers="headers"
        :items="items"
        :items-per-page="globalItemsPerPage"
        :loading="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        style="margin-bottom: 80px;"
        >
          <template v-slot:item.timeCreated="{ item }" >{{ formatDateTime(item.timeCreated) }}</template>
          <template v-slot:item.timeModified="{ item }" >{{ formatDateTime(item.timeModified) }}</template>
          <template v-slot:item.actions="{ item }" >
            <v-btn outlined @click.stop="selectItem(item)">Select</v-btn>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-btn @click="createNew" fab id="addButton" color="success"><v-icon>add</v-icon></v-btn>
  </v-container>

</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      headers: [
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Created', value: 'timeCreated' },
        { text: 'Modified', value: 'timeModified' }
      ],
      items: [],
      loading: false,
      options: {},
      totalItems: 0
    }
  },

  created () {
    this.getData()
  },

  computed: {
    ...mapGetters([
      'isOrgAdmin',
      'selectedOrganization'
    ])
  },

  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },

  methods: {
    ...mapMutations([
      'setSite'
    ]),

    createNew: function () {
      this.$router.push({ name: 'siteEdit', params: { id: 'new' } })
    },

    getData: function () {
      if (this.options.page !== undefined) {
        this.loading = true

        var params = {}
        if (this.options.itemsPerPage > 0) {
          params.page = this.options.page - 1
          params.limit = this.options.itemsPerPage
        }

        if (this.selectedOrganization._id && this.isOrgAdmin) {
          params.org = this.selectedOrganization._id
        }

        if (this.options.sortBy.length > 0) {
          params.sort = ''
          if (this.options.sortDesc[0]) {
            params.sort = '-'
          }
          params.sort = params.sort + this.options.sortBy[0]
        }

        ApiRequests.siteQuery(params).then(r => {
          this.items = r.data
          this.totalItems = parseInt(r.headers['x-total-count'])
          this.loading = false
        })
      }
    },

    selectItem: function (item) {
      this.setSite(item)
    },

    selectRow: function (item) {
      this.$router.push({ name: 'siteEdit', params: { id: item._id } })
    }
  }
}
</script>
